import React from 'react';

import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { LogoutRequestedRootEvent } from '@/router/state/root/component/root-event';
import { useRootActorRef } from '@/router/state/root/util/context/helpers';

interface LogoutConfirmationModalProps {
  trigger?: React.ReactNode;
  className?: string;
}

export const LogoutConfirmationModal: React.FC<LogoutConfirmationModalProps> = ({
  trigger,
  className,
}) => {
  const { t } = useTranslation('common');
  const actorRef = useRootActorRef();
  const [open, setOpen] = React.useState(false);

  const handleConfirm = () => {
    setOpen(false);
    actorRef.send(new LogoutRequestedRootEvent());
  };

  const defaultTrigger = (
    <Button variant="ghost" size="sm" className={className}>
      <LogOut />
      {t('logout')}
    </Button>
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger ?? defaultTrigger}</DialogTrigger>

      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t('logoutConfirmation.title')}</DialogTitle>
          <DialogDescription>{t('logoutConfirmation.message')}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>
            {t('cancel')}
          </Button>
          <Button onClick={handleConfirm}>{t('logout')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
